import { getMemberDisplayName } from './deviceIdentity';

export function memberNoteKey(member) {
  if (!member || typeof member !== 'object') return '';
  return String(member.device_unique_id || member.name || '').trim();
}

export function emptyMemberNote(memberKey = '') {
  return {
    member_key: memberKey,
    remark_name: '',
    phones: [],
    description: ''
  };
}

/** 列表显示名：有指挥员私有备注名则用备注名，否则队员自设名 */
export function getMemberListDisplayName(member, notesByKey = null) {
  const key = memberNoteKey(member);
  const note = key && notesByKey ? notesByKey[key] : null;
  const remark = String(note?.remark_name || '').trim();
  if (remark) return remark;
  return getMemberDisplayName(member);
}

export function getMemberRealName(member) {
  return getMemberDisplayName(member);
}
